import { ISidebarData } from "@/types/sidebar.types";

import {
  CircleQuestionMark,
  CircleUserRound,
  FileBadge,
  FileText,
  Hotel,
  LayoutDashboard,
  MoonStar,
  PlaneTakeoff,
  TreePalm,
  UserRoundCog,
  UsersRound
} from "lucide-react";

export const sidebarData: ISidebarData = {
  navGroups: [
    {
      title: "General",
      items: [
        {
          title: "Dashboard",
          url: "/dashboard",
          icon: LayoutDashboard,
        },
      ],
    },
    {
      title: "Profile",
      items: [
        {
          title: "Profile Settings",
          url: "/dashboard/my-profile",
          icon: CircleUserRound,
        },
        {
          title: "Account & Security",
          url: "/dashboard/account",
          icon: UserRoundCog,
        },
      ],
    },
    {
      title: "Bookings",
      items: [
        {
          title: "Flight",
          url: "/dashboard/bookings/flight",
          icon: PlaneTakeoff,
        },
        {
          title: "Hotel",
          url: "/dashboard/bookings/hotel",
          icon: Hotel,
        },
        {
          title: "Holiday",
          url: "/dashboard/bookings/holiday",
          icon: TreePalm,
        },
        {
          title: "Umrah",
          icon: MoonStar,
          items: [
            {
              title: "Packages",
              url: "/dashboard/bookings/umrah",
              icon: TreePalm,
            },
            {
              title: "Custom",
              url: "/dashboard/bookings/umrah/custom",
              icon: CircleUserRound,
            },
          ],
        },
        {
          title: "Visa",
          url: "/dashboard/bookings/visa",
          icon: FileBadge,
        },
      ],
    },
    {
      title: "Payment",
      items: [
        {
          title: "Invoices",
          url: "/dashboard/invoices",
          icon: FileText,
        },
      ],
    },
    {
      title: "Others",
      items: [
        {
          title: "Traveler Profiles",
          url: "/dashboard/travelers",
          icon: UsersRound,
        },
        {
          title: "Help & Support",
          url: "/dashboard/help-support",
          icon: CircleQuestionMark,
        },

      ]
    }
  ],
};
